export { default } from './HowTo';
